export function getForeignLabel(level: string) {
    switch (level) {
        case "level-1": return "Initiator";
        case "level-2": return "Fi User";
        case "level-3": return "GST User";
        case "level-4": return "TDS User";
        case "level-5": return "Approver 1";
        case "level-6": return "Approver 2";
        case "level-7": return "Approver 3";
        default: return null;
    }
}